// When building the app with a specified configuration (e.g. prod build)
// this file is replaced by the associated file in the src/environments
// folder. So we simply can use "import { Config } from '~/config'" in
// our code and let Angular take care of the correct config values to use.
export { Config } from 'src/environments/environment';
